/*
 * @Description: 灰度配置
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { defineStore } from 'pinia';
import { setService } from '@/api/';

export const useGrayscaleStore = defineStore('getGrayscaleStore', {
  state: () => ({
    grayList: {}
  }),

  actions: {
    async getGrayScale() {
      try {
        const res = await setService.getGrayScale();
        if (res?.error || !res?.result) {
          console.warn('获取灰度配置失败');
          return;
        }
        const result = res.result || {};
        console.log('获取灰度配置成功:-0', result);
        // 获取属性，如果不存在则默认为false，由于后端接口改造升级，这是V2版本，需要保留之前的接口返回值,所以这里需要添加1/2/3这三个属性
        this.grayList = result;
        console.log('获取灰度配置成功:-1', this.grayList);
      } catch (error) {
        console.error('获取灰度配置异常:', error);
      }
    }
  }
});
export default useGrayscaleStore;
